<div class="main-content">
  <div class="row w-100 m-0 no-gutters">
    <div class="col-lg-6 col-12 d-flex flex-column justify-content-center p-sm-5 p-3">
      <div class="auth-box shadow-sm mb-5 p-sm-5 p-4 rounded-4 bg-white mx-auto w-100" style="max-width: 500px;">
        <h2 class="mb-4 fw-bold text-dark text-center">Additional Details</h2>
        <p class="text-muted text-center mb-4">Please provide these details to proceed with your application.</p>
        
        <form [formGroup]="creditForm" (ngSubmit)="onSubmit()">
          
          <!-- Residence Ownership -->
          <div class="mb-3">
            <label class="form-label text-muted small fw-bold">Residence Ownership <span class="text-danger">*</span></label>
            <select class="form-select form-select-lg w-100 p-3 bg-light border-0 rounded-4" 
                    formControlName="residenceOwnership"
                    [ngClass]="{'border border-danger': creditForm.get('residenceOwnership')?.invalid && creditForm.get('residenceOwnership')?.touched}">
              <option value="" disabled selected>Select Ownership Status</option>
              <option *ngFor="let opt of ownershipOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <div *ngIf="creditForm.get('residenceOwnership')?.invalid && creditForm.get('residenceOwnership')?.touched" class="text-danger small mt-1">
              Residence Ownership is required.
            </div>
          </div>

          <!-- Occupation -->
          <div class="mb-3">
            <label class="form-label text-muted small fw-bold">Occupation <span class="text-danger">*</span></label>
            <select class="form-select form-select-lg w-100 p-3 bg-light border-0 rounded-4" 
                    formControlName="occupation"
                    [ngClass]="{'border border-danger': creditForm.get('occupation')?.invalid && creditForm.get('occupation')?.touched}">
              <option value="" disabled selected>Select Occupation</option>
              <option *ngFor="let opt of occupationOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <div *ngIf="creditForm.get('occupation')?.invalid && creditForm.get('occupation')?.touched" class="text-danger small mt-1">
              Occupation is required.
            </div>
          </div>

          <!-- Employment Type -->
          <div class="mb-4">
            <label class="form-label text-muted small fw-bold">Employment Type <span class="text-danger">*</span></label>
            <select class="form-select form-select-lg w-100 p-3 bg-light border-0 rounded-4" 
                    formControlName="employementType"
                    [ngClass]="{'border border-danger': creditForm.get('employementType')?.invalid && creditForm.get('employementType')?.touched}">
              <option value="" disabled selected>Select Employment Type</option>
              <option *ngFor="let opt of employmentOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <div *ngIf="creditForm.get('employementType')?.invalid && creditForm.get('employementType')?.touched" class="text-danger small mt-1">
              Employment Type is required.
            </div>
          </div>

          <button type="submit" class="btn btn-primary btn-lg w-100 rounded-4 py-3 fw-bold shadow-sm" [disabled]="creditForm.invalid">
            Submit Details
          </button>

        </form>
      </div>
    </div>
  </div>
</div>
